
























import { Component, Vue, Mixins } from 'vue-property-decorator'
import DatePickerBase from '@/components/atoms/DatePickerBase.vue'
import SelectBase from '@/components/atoms/SelectBase.vue'
import TitleBase from '@/components/atoms/TitleBase.vue'
import TitleTextBase from '@/components/atoms/TitleTextBase.vue'
import ColoredBox from '@/components/atoms/ColoredBox.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import TableBase from '@/components/atoms/TableBase1110.vue'
import { ENGLISH_PUBLISHER_OPTIONS, GRADE_IDS_OPTIONS, TEACHER_SETTING_TEXT } from '@/constants'
import { AlignedCourses, StandardCourses, StudentInfo } from '@/store/modules/StudentCreationInfo'
import dayjs from 'dayjs'
import { SUBJECTS } from '@/components/organisms/SelectCoursesStandardTable.vue'
import QueryMethods from '@/components/atoms/QueryMethods.vue'
import StudentIdsInfo from './StudentIdsInfo.vue'

const PUBLISHER_DEFAULT = 'hy'
const PUBLISHER_DEFAULT_TEXT = '標準'
export const COURSE_TEXTS = {
  aligned: '準拠',
  standard: '標準',
}

export type StudentTable = {
  nickname: string
  studentCode: string
  schoolName: string
  gradeName: string
  studentId?: string
}

@Component({
  components: {
    SelectBase,
    TitleBase,
    TitleTextBase,
    ColoredBox,
    DatePickerBase,
    ButtonBase,
    TableBase,
  },
})
export default class StudentConfirm extends Mixins(QueryMethods, StudentIdsInfo) {
  private breadcrumbs = [
    { text: TEACHER_SETTING_TEXT, href: '/teacher/setting/top' },
    { text: '生徒', href: '/teacher/setting/v3/student' },
    { text: '生徒新規追加', to: '/teacher/setting/v3/student/create/info' },
    { text: '申込内容確認', active: true },
  ]
  private studentCreationInfo: StudentInfo = this.$store.state.studentCreationInfo.studentInfo

  private studentInfoItems: StudentTable[] = []
  private studentCourseItems: object[] = []

  private studentInfoFields: object[] = [
    { key: 'nickname', label: '生徒氏名' },
    { key: 'studentCode', label: '生徒ID' },
    { key: 'schoolName', label: '学校名' },
    { key: 'gradeName', label: '学年' },
  ]

  private studentCourseFields: object[] = [
    { key: 'grade', label: '学年' },
    { key: 'subject', label: '教科' },
    { key: 'course', label: 'コース' },
    { key: 'publisher', label: '教科書会社' },
    { key: 'date', label: '利用期間' },
  ]

  private handleSubmit() {
    if (this.isMultiStudent) {
      this.handleUpdateStudents()
    } else if (this.userIds.length === 1) {
      this.handleUpdateStudent()
    } else {
      this.handleCreateStudent()
    }
  }
  private handleError(err: any) {
    if (err?.response?.data?.status === 409) {
      alert('生徒IDが存在します')
    } else {
      alert(err?.response?.data.message || 'error')
    }
  }
  private async handleCreateStudent() {
    Vue.prototype.$loading.start()
    const { nickname, studentCode, schoolSelected, gradeSelected, standardCourses, alignedCourses, month, date } =
      this.studentCreationInfo
    const payload = {
      branch_id: this.branchId,
      nickname,
      code: studentCode,
      school_id: Number(schoolSelected),
      grade_id: Number(gradeSelected),
      student_services: this.handleStandardCoursesData(standardCourses),
      aligned_users_publishers: this.handleAlignedCoursesData(alignedCourses),
      aligned_user_course_period:
        date && month && this.handleAlignedCoursesData(alignedCourses).length
          ? this.handleAlignedDate(date, month)
          : {},
    }
    await Vue.prototype.$http.httpWithToken
      .post('/v3/students', payload)
      .then(() => {
        this.$store.commit('studentCreationInfo/resetStudentInfo')
        this.$router.push('/teacher/setting/v3/student/create/confirm-success')
      })
      .catch(this.handleError)
      .finally(() => {
        Vue.prototype.$loading.complete()
      })
  }

  private async handleUpdateStudents() {
    Vue.prototype.$loading.start()
    const { standardCourses, alignedCourses, month, date } = this.studentCreationInfo
    const payload = {
      student_ids: this.studentInfoItems.map((student) => student.studentId),
      student_services: this.handleStandardCoursesData(standardCourses),
      aligned_users_publishers: this.handleAlignedCoursesData(alignedCourses),
      aligned_user_course_period:
        date && month && this.handleAlignedCoursesData(alignedCourses).length
          ? this.handleAlignedDate(date, month)
          : {},
    }
    await Vue.prototype.$http.httpWithToken
      .patch('/v3/students/courses', payload)
      .then(() => {
        this.$store.commit('studentCreationInfo/resetStudentInfo')
        this.$router.push('/teacher/setting/v3/student/create/confirm-success')
      })
      .catch(this.handleError)
      .finally(() => {
        Vue.prototype.$loading.complete()
      })
  }

  private async handleUpdateStudent() {
    Vue.prototype.$loading.start()
    const { standardCourses, alignedCourses, month, date, nickname, studentCode, schoolSelected, gradeSelected } =
      this.studentCreationInfo
    const param = this.getParamsObject()
    const payload = {
      branch_id: this.branchId,
      nickname,
      code: studentCode,
      school_id: Number(schoolSelected),
      grade_id: Number(gradeSelected),
      student_services: this.handleStandardCoursesData(standardCourses),
      aligned_users_publishers: this.handleAlignedCoursesData(alignedCourses),
      aligned_user_course_period:
        date && month && this.handleAlignedCoursesData(alignedCourses).length
          ? this.handleAlignedDate(date, month)
          : {},
    }
    await Vue.prototype.$http.httpWithToken
      .patch(`/v3/students/${param['studentId']}`, payload)
      .then(() => {
        this.$store.commit('studentCreationInfo/resetStudentInfo')
        this.$router.push('/teacher/setting/v3/student/create/confirm-success')
      })
      .catch(this.handleError)
      .finally(() => {
        Vue.prototype.$loading.complete()
      })
  }

  private backToStudentInfo() {
    this.$router.push(
      `/teacher/setting/v3/student/create/info?id=${this.userIds.join(',')}&studentId=${
        this.getParamsObject()['studentId']
      }`
    )
  }

  private handleStudentInfoTable(studentCreationInfo: StudentInfo) {
    const schoolName =
      this.schoolOptions.find((school) => school.value === Number(studentCreationInfo.schoolSelected))?.text || ''
    const gradeName =
      GRADE_IDS_OPTIONS.find((grade) => grade.value === Number(studentCreationInfo.gradeSelected))?.text || ''
    this.studentInfoItems = [
      {
        nickname: studentCreationInfo.nickname || '',
        studentCode: studentCreationInfo.studentCode || '',
        schoolName,
        gradeName,
      },
    ]
  }

  private handleStandardCoursesData(standardCourses?: StandardCourses) {
    return standardCourses
      ? Object.entries(standardCourses).map(([subject, checked]) => ({
          subject_id: subject,
          is_enabled: checked,
        }))
      : []
  }

  private handleAlignedCoursesData(alignedCourses?: AlignedCourses) {
    const alignedCoursesData: { subject_id: number; publisher_code?: string; grade_id: number }[] = []
    if (!alignedCourses) return []
    Object.entries(alignedCourses).forEach(([grade, subjects]) => {
      Object.entries(subjects).forEach(([subject, { checked, publisher }]) => {
        if (checked) {
          alignedCoursesData.push({
            grade_id: Number(grade),
            subject_id: Number(subject),
            publisher_code: publisher || PUBLISHER_DEFAULT,
          })
        }
      })
    })
    return alignedCoursesData
  }

  private handleAlignedDate(date: string, month: string) {
    return {
      start_date: date,
      end_date: dayjs(date).add(Number(month), 'month').subtract(1, 'day').format('YYYY/MM/DD'),
    }
  }

  private findSubjectNameById(id: string): string {
    for (const key in SUBJECTS) {
      if (SUBJECTS[key as keyof typeof SUBJECTS].id === id) {
        return SUBJECTS[key as keyof typeof SUBJECTS].name
      }
    }
    return ''
  }

  private handleStudentAlignedCourseTable(studentCreationInfo: StudentInfo) {
    const { alignedCourses: courses, date: startDate, month } = studentCreationInfo
    if (!courses) return
    const date = dayjs(startDate)
    const endDate = date.add(Number(month), 'month').subtract(1, 'day').format('YYYY/MM/DD')
    Object.entries(courses).forEach(([gradeKey, gradeValue]) => {
      Object.entries(gradeValue).forEach(([subjectKey, subjectValue]) => {
        const { checked, publisher } = subjectValue
        const gradeText = GRADE_IDS_OPTIONS.find((option) => option.value === Number(gradeKey))?.text
        const publisherText = ENGLISH_PUBLISHER_OPTIONS.find((option) => option.value === publisher)?.text
        const subjectText = this.findSubjectNameById(subjectKey)
        if (checked) {
          this.studentCourseItems.push({
            grade: gradeText,
            subject: subjectText,
            publisher: publisherText || PUBLISHER_DEFAULT_TEXT,
            course: COURSE_TEXTS.aligned,
            date: `${startDate} ～ ${endDate}${'　'}${month}ヶ月`,
          })
        }
      })
    })
  }

  private handleStudentStandardCourseTable(studentCreationInfo: StudentInfo) {
    const { standardCourses: courses } = studentCreationInfo
    if (!courses) return
    Object.entries(courses).forEach(([subjectKey, checked]) => {
      const subjectText = this.findSubjectNameById(subjectKey)
      if (checked) {
        this.studentCourseItems.push({
          grade: 'ー',
          subject: subjectText,
          publisher: 'ー',
          course: COURSE_TEXTS.standard,
          date: 'ー',
        })
      }
    })
  }

  private async getStudentsInfo() {
    await Vue.prototype.$http.httpWithToken
      .get(`/v3/students`, { params: { branchId: this.branchId, userId: this.userIds.join(',') } })
      .then((res: any) => {
        this.studentInfoItems = res.data.students.map((student: StudentTable) => {
          return {
            nickname: student.nickname,
            studentCode: student.studentCode,
            schoolName: student.schoolName,
            gradeName: student.gradeName,
            studentId: student.studentId,
          }
        })
      })
  }

  private async validateAndInitializeUserInfo() {
    const studentCreationInfo: StudentInfo = this.studentCreationInfo
    const { nickname, studentCode, schoolSelected, date, month, gradeSelected, alignedCourses, standardCourses } =
      studentCreationInfo
    const validCourse =
      this.isChooseStandardCourses(standardCourses) || (this.isChooseAlignedCourses(alignedCourses) && date && month)
    const validInfoStudent = nickname && studentCode && schoolSelected && gradeSelected && validCourse
    const validInfoStudents = validCourse

    if (this.isMultiStudent ? !validInfoStudents : !validInfoStudent) {
      alert('情報をすべて入力してください。')
      this.$router.push(`/teacher/setting/v3/student/create/info?id=${this.userIds.join(',')}`)
      return
    }

    if (this.isMultiStudent) {
      await this.getStudentsInfo()
    } else {
      await this.loadSchools()
      this.handleStudentInfoTable(this.studentCreationInfo)
    }

    this.handleStudentAlignedCourseTable(this.studentCreationInfo)
    this.handleStudentStandardCourseTable(this.studentCreationInfo)
  }

  private async mounted() {
    Vue.prototype.$loading.start()
    await this.setParamsFromQuery()
    await this.validateAndInitializeUserInfo()
    Vue.prototype.$loading.complete()
  }
}
